module.exports = "div{border-radius:50%;position:relative}.user-image{border-radius:50%;border-width:5px;position:absolute}.text-footer{color:#9E9E9E;font-size:14px}.text-footer.ui-alt{color:#f5f5f5 !important}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ui/dynamic-image/dynamic-image.component.scss
// module id = 636
// module chunks = 0